/*-----------------------------------------------------------------
- Components translations
-----------------------------------------------------------------*/

export default {
    uploader: {
        drag: {
            single  : 'Drop your file here.!',
            multiple: 'Drop your files here!',
        },

        button: {
            small   : 'Select the file',
            single  : 'Or select your file',
            multiple: 'Or choose your files',
        },

        add                         : 'Find the file',
        dictRemoveFile              : 'Delete File',
        dictRemoveFileConfirmation  : 'Do you trust the removal of the file?',
        dictCancelUpload            : 'never mind!',
        dictUploadCanceled          : 'The upload process stopped!',
        dictCancelUploadConfirmation: 'Do you make sure of stopping the upload process?',
        dictFileTooBig              : 'The file size is high ({filesize} MB).Maximum file size is {maxFilesize} MB. ',
        dictInvalidFileType         : 'It is not possible to upload a file with this format.',
        dictResponseError           : 'Communication disorder.',
        dictMaxFilesExceeded        : 'You can not upload more than {maxFiles} files.',

        size          : 'Megabyte',
        uploading     : 'Your file is loading.',
        stop_uploading: 'Stop loading',
    },

    date_picker: {
        addon: {
            date    : 'Date',
            time    : 'Time',
            datetime: 'Date',
            year    : 'Year',
            month   : 'Month',
        },
    },
};
